import { Theme } from '@ltvco/refresh-lib/theme';

export enum PROPERTY_SEARCH_TYPES {
  // eslint-disable-next-line no-unused-vars
  ADDRESS_REPORT = 'addressReport',
  // eslint-disable-next-line no-unused-vars
  PRE_FORECLOSURES = 'preForeclosures',
}

export interface PropertyFormData {
  address: string;
  searchType: string;
}

export type RapidsStateRef = {
  getValue: () => string;
  resetValue: () => void;
};

export const searchTypeOptions = [
  { value: PROPERTY_SEARCH_TYPES.ADDRESS_REPORT, label: 'Address Report' },
  { value: PROPERTY_SEARCH_TYPES.PRE_FORECLOSURES, label: 'Pre-foreclosures' },
];

export const getPlaceholderTextForPropertySearch = (
  activeTab: string,
  isMobile?: boolean
): string => {
  const placeholderText = {
    [PROPERTY_SEARCH_TYPES.ADDRESS_REPORT]: 'e.g. 123 Main St. New York, NY',
    [PROPERTY_SEARCH_TYPES.PRE_FORECLOSURES]: 'Enter a city, state or ZIP code',
  };

  const placeholderTextMobile = {
    [PROPERTY_SEARCH_TYPES.ADDRESS_REPORT]: 'Address',
    [PROPERTY_SEARCH_TYPES.PRE_FORECLOSURES]: 'New York, NY',
  };

  const placeholderMap = isMobile ? placeholderTextMobile : placeholderText;
  return placeholderMap[activeTab as keyof typeof placeholderMap];
};

export const rapidsInputCustomStyles = (theme: Theme) => ({
  borderRadius: '32px',

  '& .MuiAutocomplete-root': {
    width: '100%',
    height: '100%',

    '& .address-input-container': {
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        justifyContent: 'center',
      },
    },

    '& .address-input': {
      '& .MuiOutlinedInput-root': {
        border: 'none',
        borderRadius: '50px',
      },

      '& .MuiOutlinedInput-notchedOutline': {
        height: '52px',
        border: 'none',
      },

      '& .MuiAutocomplete-input': {
        height: '32px',
      },

      // Hide default search clear buttons across browsers
      '& input[type="search"]::-webkit-search-cancel-button': {
        WebkitAppearance: 'none',
        appearance: 'none',
        display: 'none',
      },

      // For Firefox
      '& input[type="search"]::-moz-search-clear': {
        display: 'none',
      },

      // For IE
      '& input[type="search"]::-ms-clear': {
        display: 'none',
      },

      // Generic
      '& input[type="search"]': {
        appearance: 'none',
      },

      '& .rapids-search-icon': {
        display: 'none',
      },
    },
  },
});
